import router from './router'
import store from './store'

import { Message } from 'element-ui'
import { getToken, setToken } from '@/utils/auth' // getToken from cookie

router.beforeEach((to, from, next) => {

	if(to.path == '/login') {
		setToken('');
		next();
	} else {
		let Token = getToken();

		if(Token) {

			if(store.getters.nenus.length > 0) {

				next()

			} else { //没有获取路由表，则获取路由表，和个人信息
				store.dispatch("GetUserInfo").then(res => {})
				next()
			}
		} else {
			next({
				path: '/login'
			})
		}
	}

})

router.afterEach(transition => {

});